/**
 * footer
 */

(function ($) {
    var url = "https://api.staging.niagaramodules.com";
    
    function subscribe(email){
        $('#subscribeError').hide();
        $('#subscribeSuccess').hide();
        if(email == ''){
            raiseError("blank");
            return;
        }
        if(validateEmail(email)){
            loading();
            $.post(url + "/sendgrid/subscribe", {
                email: email
            }, onSubscribe);
        }else{
            raiseError("invalid");
        }
    }

    function onSubscribe(data, statusText, jqXHR){
        if(statusText == "success"){
            status(data.job_id)
        }else{
            raiseError("retry");
            console.log("Error subscribing", data, statusText, jqXHR);
        }
    }

    function status(job_id){
        $.ajax(url + "/jobs/status/"+job_id, { success: onStatus });
    }

    function onStatus(data, statusText, jqXHR){
        if(data.status != "complete"){
            setTimeout(function(){
                status(data.id);
            }, 1500);
        }else{
            if(data.successful){
                success();
            }else{
                raiseError("retry");
                console.log("error subscribing", data, statusText, jqXHR);
            }
        }
    }

    function loading(){
        $('#subscribeEmail').prop('disabled', true);
        $('#subscribeButton').prop('disabled', true);
        $('#subscribeLoading').css('display', 'flex');
    }

    function doneLoading(){
        $('#subscribeEmail').prop('disabled', false);
        $('#subscribeButton').prop('disabled', false);
        $('#subscribeLoading').hide();
    }

    function success(){
        doneLoading();
        $('#subscribeSuccess').css('display', 'inline-flex');
    }

    function raiseError(type){
        doneLoading();
        var msg = "Error";
        switch(type){
            case "blank":
                msg = "You must enter an email address";
                break;
            case "invalid":
                msg = "You must enter a valid email address";
                break;
        }
        $('#subscribeError').html(msg);
        $('#subscribeError').show();
    }

    function validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    $('#subscribeButton').click(function(){
        subscribe($('#subscribeEmail').val());
    });

})(window.jQuery);
